import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Residential } from "@/components/site/Residential";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { OurWorkTeaser } from "@/components/site/OurWorkTeaser";
import { Commercial } from "@/components/site/Commercial";
import { Logistics } from "@/components/site/Logistics";
import { WhyPerfectTouch } from "@/components/site/WhyPerfectTouch";
import { EcoSurface } from "@/components/site/EcoSurface";
import { ServiceAreas } from "@/components/site/ServiceAreas";
import { GoogleReviews } from "@/components/site/GoogleReviews";
import { ClientPolicy } from "@/components/site/ClientPolicy";
import { NotSure } from "@/components/site/NotSure";
import { FAQ } from "@/components/site/FAQ";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  // Reliably scroll to a deep-link anchor (e.g. /#deep-cleaning) on load and on
  // hash change. Runs after layout settles so lazy-loaded images don't offset it,
  // and bypasses the Lenis/native hash-jump race.
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    const timers = [setTimeout(scrollToHash, 500), setTimeout(scrollToHash, 1400)];
    window.addEventListener("hashchange", scrollToHash);
    return () => {
      timers.forEach(clearTimeout);
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);

  return (
    <div className="bg-[#050505] min-h-screen">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Residential />
        <BeforeAfter />
        <OurWorkTeaser />
        <Commercial />
        <Logistics />
        <span id="about-us" aria-hidden="true" className="block scroll-mt-28" />
        <WhyPerfectTouch />
        <EcoSurface />
        <ServiceAreas />
        <GoogleReviews />
        <ClientPolicy />
        <NotSure />
        <FAQ />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
